interface SocialPostCardSkeletonProps {
  className?: string;
}

export function SocialPostCardSkeleton({ className = '' }: SocialPostCardSkeletonProps) {
  return (
    <div className={`animate-pulse rounded-lg bg-white shadow-sm ${className}`}>
      {/* Video/Image placeholder */}
      <div className="aspect-[3/4] w-full rounded-t-lg bg-zinc-200" />

      {/* Content area */}
      <div className="space-y-2 p-3">
        {/* Description lines */}
        <div className="space-y-1">
          <div className="h-3 w-full rounded bg-zinc-200" />
          <div className="h-3 w-3/4 rounded bg-zinc-200" />
        </div>

        {/* Stats area */}
        <div className="flex items-center justify-between pt-2">
          <div className="flex items-center gap-3">
            <div className="h-3 w-12 rounded bg-zinc-200" />
            <div className="h-3 w-12 rounded bg-zinc-200" />
          </div>
          <div className="h-3 w-16 rounded bg-zinc-200" />
        </div>
      </div>
    </div>
  );
}
